import {
  FilterType,
  buildDocumentsDataTableFilter,
  useDocumentsDataTable,
} from 'generated/resources/datatable.graphql'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

const deletedAtFilter = (source: ReturnType<typeof useDocumentsDataTable>) =>
  buildDocumentsDataTableFilter(source, {
    type: FilterType.Date,
    categories: [
      {
        kind: 'DateTimePicker',
        operation: 'between',
        value: [
          dateToString(moment().startOf('week'), 'backend_datetime'),
          dateToString(moment(), 'backend_datetime'),
        ],
      },
    ],
    identifier: 'deleted_at',
    path: 'deletedAt',
    title: i18n.t('documents.employee.list.deleted_at'),
  })

export default deletedAtFilter
